// テキスト / 付箋の本文中に含まれる URL を検出し、リンク化のためのセグメントへ分割する純粋ユーティリティ。
//
// セキュリティ方針: リンク化・遷移の対象は http / https スキームのみに限定する。javascript: / data: 等は
// URL 検出の正規表現（https?:// 始まり）で一次的に弾き、isHttpUrl で二次的に検証する多層防御とする。
//
// **分割判定そのものは domain の markdown-source-map.ts を正本とする。** 編集 DOM・非編集表示・
// PDF・部分書式（inline style run）の raw offset 対応が同じ判定を参照するため、判定は domain 側へ
// 移し、本モジュールは互換の再輸出と「ブラウザ環境に依存する外部リンク判定」だけを持つ。

import {
  findUrlTokenAt,
  isHttpUrl,
  splitTextIntoLinkSegments,
  type LinkSegment,
} from "@refinement-canvas/domain";

export { findUrlTokenAt, isHttpUrl, splitTextIntoLinkSegments };
export type { LinkSegment };

/**
 * リンク記法を非対話の派生表示（PDF・サムネイル等）へ描くための表示文字列へ変換する。
 * Markdown リンクは表示名だけを残し、素の URL と通常テキストは入力どおりに保持する。
 */
export function displayTextOfLinkifiedText(text: string): string {
  return splitTextIntoLinkSegments(text)
    .map((segment) => segment.value)
    .join("");
}

/**
 * 外部リンク判定: URL のオリジンが現在のページ（selfOrigin）と異なるものを外部とみなす。
 * 同一オリジン（アプリ自身のキャンバス URL 等）は内部リンクとして同一タブで開く。
 * URL の解釈に失敗した場合は安全側（外部扱い = 別タブ + noopener）へ倒す。
 */
export function isExternalHttpUrl(
  url: string,
  selfOrigin: string = typeof window === "undefined" ? "" : window.location.origin,
): boolean {
  try {
    return new URL(url).origin !== selfOrigin;
  } catch {
    return true;
  }
}
